module.exports = __webpack_public_path__ + "img/AC_Braddock.6ef53122.jpg";